<script setup lang="ts">
/**
 * Card "Pourquoi soutenir Donoor ?" (couleur crème).
 * Partagée /a/[slug] (action="adhésion") et /b/[slug] (action="réservation").
 */
defineProps<{
  organizationName?: string | null;
  action: string;
}>();

const { t } = useI18n();
</script>

<template>
  <div class="bg-[#fffbf5] dark:bg-[#1a1710] rounded-3xl shadow-[0_1px_3px_rgba(45,46,92,0.12)] p-5">
    <p class="text-sm font-bold text-[#2d2e5c] dark:text-white mb-3">
      {{ t("association.publicPage.brandingCard.titre") }}
    </p>
    <img
src="/svg/hands-heart.svg" alt="" class="w-20 h-20 mx-auto mb-3"
      width="196"
      height="200"
    />
    <i18n-t
      keypath="association.publicPage.brandingCard.texte"
      tag="p"
      class="text-xs text-[#505870] dark:text-gray-400 leading-relaxed"
    >
      <template #action>{{ action }}</template>
      <template #nom>
        <span class="font-semibold text-[#2d2e5c] dark:text-white">{{ organizationName || t('association.publicPage.brandingCard.cetteAssociation') }}</span>
      </template>
    </i18n-t>
  </div>
</template>
